module.exports = __webpack_public_path__ + "static/media/ic-school.238443f8.svg";